Ext.define('SA.AcsTable.TableSearchPopupContent', {
    alias: 'widget.acs-table-search-popup-content',
    extend: 'Ext.Component',

    cls: 'sa-acs-table-search-popup-content',

    tpl: [
        '<tpl for=".">',
            '<button class="sa-acs-table-search-result-btn" data-table-id="{id}">',
                '{name}',
            '</button>',
        '</tpl>',
    ],

    setData(data) {
        this.update(data);
    }
});